import { render, staticRenderFns } from "./KioskList.vue?vue&type=template&id=89442a9a&"
import script from "./KioskList.vue?vue&type=script&lang=js&"
export * from "./KioskList.vue?vue&type=script&lang=js&"
import style0 from "./KioskList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports